import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { getFont } from '@finect/tabular-utils/getFont';

export const Step = styled.span`
  display: block;
  position: relative;
  padding-left: 48px;
  ${getFont(1, 'compact')};

  ${maxMediaQueries.miniDesktop`
    ${getFont(0)};
  `};

  &:before {
    position: absolute;
    left: 0;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    content: counters(steps, '');
    counter-increment: steps;
    background-color: ${({ theme }) => theme.secondaryColor};
    font-family: ${({ theme }) => theme.bodyFontFamily};
    font-weight: 600;
    ${fontSmoothing};
    line-height: 30px;
    color: #fff;
    text-align: center;
  }
`;
